import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/resourceSelection/selectedResourcesList/selectedEveryone/styles.scss';export default {
  "selectedEveryone": "_selectedEveryone_locre_1",
  "removeIcon": "_removeIcon_locre_23",
  "resource": "_resource_locre_38",
  "removeButton": "_removeButton_locre_45"
};